import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';

interface InnerProps {
  children?: React.ReactNode;
  fallbackTitle?: React.ReactNode;
  onGoHome: () => void;
}

interface InnerState {
  hasError: boolean;
  error: Error | null;
}

class PageErrorBoundaryInner extends Component<InnerProps, InnerState> {
  constructor(props: InnerProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="screen"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '32px 24px',
          }}
        >
          <div
            className="panel"
            style={{
              padding: '32px 36px',
              textAlign: 'left',
              maxWidth: 560,
              borderLeft: '2px solid var(--bear)',
            }}
          >
            <div
              className="tab-sm"
              style={{
                color: 'var(--bear)',
                letterSpacing: '0.12em',
                fontSize: 10,
                marginBottom: 12,
              }}
            >
              ◆ ERROR
            </div>
            <h2
              className="serif"
              style={{
                fontSize: 24,
                fontWeight: 700,
                letterSpacing: '-0.02em',
                marginBottom: 10,
              }}
            >
              {this.props.fallbackTitle || 'Something went wrong'}
            </h2>
            <p
              className="mono"
              style={{
                color: 'var(--text-2)',
                fontSize: 12,
                lineHeight: 1.55,
                marginBottom: 20,
              }}
            >
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <button type="button" onClick={this.handleRetry} className="btn btn-primary">
                Try again →
              </button>
              <button type="button" onClick={this.props.onGoHome} className="btn">
                Go home
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function PageErrorBoundary({
  children,
  fallbackTitle,
}: {
  children?: React.ReactNode;
  fallbackTitle?: React.ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <PageErrorBoundaryInner fallbackTitle={fallbackTitle} onGoHome={() => navigate('/')}>
      {children}
    </PageErrorBoundaryInner>
  );
}
